/**
 * Suntelco brand logo. Uses the real image asset.
 * variant: "dark" -> raw image on light backgrounds
 *          "light" -> image inside a white rounded pill so the dark mark stays visible on dark backgrounds
 */
export default function Logo({ variant = "dark", className = "", size = "md" }) {
  const heights = { sm: "h-8", md: "h-11", lg: "h-14" };
  const h = heights[size] || heights.md;
  const src = "/brand/suntelco-logo.png";

  if (variant === "light") {
    return (
      <span
        className={`inline-flex items-center bg-white rounded-xl px-3 py-1.5 shadow-[0_8px_24px_-12px_rgba(0,0,0,0.4)] ${className}`}
      >
        <img src={src} alt="Suntelco" className={`${h} w-auto`} />
      </span>
    );
  }

  return (
    <span className={`inline-flex items-center ${className}`}>
      <img src={src} alt="Suntelco" className={`${h} w-auto`} />
    </span>
  );
}
